import { action } from "typesafe-actions";
import { ICourseAndBatchReport,  } from "./type";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { showMessage } from "../messages/messagesActions";
import { api } from "../../api/api";




export const  FETCH_COURSE_REPORT_LIST_PROGRESS = "FETCH_COURSE_REPORT_LIST_PROGRESS";
export const  FETCH_COURSE_REPORT_LIST_SUCCESS = "FETCH_COURSE_REPORT_LIST_SUCCESS";
export const  FETCH_COURSE_REPORT_LIST_FAILED = "FETCH_COURSE_REPORT_LIST_FAILED";


export const fetchCourseReportListProgress = () => 
    action(FETCH_COURSE_REPORT_LIST_PROGRESS);

export const fetchCourseReportListSuccess = (data: ICourseAndBatchReport[], singleReport: ICourseAndBatchReport,totalRecords: number, totalFee: number, feesPaid: number, pendingFee: number ) =>
    action(FETCH_COURSE_REPORT_LIST_SUCCESS, {
        data, singleReport, totalRecords, totalFee, feesPaid, pendingFee
    });

export const fetchCourseReportListFailed = () =>
    action(FETCH_COURSE_REPORT_LIST_FAILED);


export const fetchCourseandbatchReportListAsync =
  (
     date: IDataTableV2DateState["dates"],
         organizationUUID: string,
        courseUUID?: string,
        batch?: string,
        acedmicYear?: number
       
 ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCourseReportListProgress()); 

      let url =""
      if(organizationUUID){
        url+= `&organizations_uuid=${organizationUUID}`
      }
      if(courseUUID){
        url+= `&courses_uuid=${courseUUID}`
      }
       if (batch){
        url+= `&batch=${batch}` 
       }
       if(acedmicYear){
        url+= `&academic_year=${acedmicYear}`

       }
      const res = await api.get(
        `report/get-course-and-batch-wise-data?&from_date=${date.fromDate}&to_date=${date.toDate}`+url
      );

      const data: ICourseAndBatchReport[] = res.data.data.result;
      const totalFee = res.data.data.total_fee_amount;
      const feesPaid = res.data.data.total_paid_fee;
      const pendingFee = res.data.data.pending_fee;
      const singleReport  = res.data.data[0];
        const totalRecords = res.data.totalRecords;
        dispatch(fetchCourseReportListSuccess(data, singleReport, totalRecords, totalFee, feesPaid, pendingFee));
       
    } catch (error: any) {
        dispatch(fetchCourseReportListFailed()); 
        dispatch(
            showMessage({
              type: "error",
              message: error.response.data.message,
              displayAs: "snackbar",
            })
        )
    }
}

export const CLEAR_COURSE_REPORT_STATE = "CLEAR_COURSE_REPORT_STATE";
export const CLEAR_COURSE_REPORT= "CLEAR_COURSE_REPORT";

export const clearCourseReportState = () => action(CLEAR_COURSE_REPORT_STATE);
export const clearCourseReport = () => action(CLEAR_COURSE_REPORT);

  
